// extracted by mini-css-extract-plugin
export default {"scroll":"ContextMenu-module__scroll--PBol6","menu":"ContextMenu-module__menu--k5niH"};